module.exports = __webpack_public_path__ + "img/deuna.c42f6ac7.png";